// extracted by mini-css-extract-plugin
module.exports = {"root":"TaskList_root__3pP7p","textContainer":"TaskList_textContainer__3sGEY","title":"TaskList_title__3Ook9","created":"TaskList_created__33_y8"};